import BaseEntity from '@/global/dejaVue/baseEntity'
import Database from './database'
import { EnumPermission } from './permission'
import { RoleEnum } from './role'

export default class User extends BaseEntity<Database> {
    public id = 0
    public nom = ''
    public prenom = ''
    public email = ''
    public roleEnum: RoleEnum = RoleEnum.NotSet
    public permissions: EnumPermission[] = []
    public role = ''
    public codeClientBiobank = ''
    public domTom = false
    public dentaire = false
    public maxilo = false
    public ortho = false
    public commerciauxAssocies = [] as string[]
    public fonction = null as null | string
    public autresInfos = null as null | string
    public desactive = false
    public inscriptionTerminee = false
    public listePMNAutorisees = [] as number[]

    public get initials() {
        const letters = `${this.prenom != '' ? this.prenom?.substr(0, 1) : ''}${this.nom != '' ? this.nom.substr(0, 1) : ''}`
        return letters != '' ? letters : 'U'
    }

    constructor(options?: any) {
        super(options)
        this.feed(options)
    }

    public feed(options?: any) {
        if (options?.id) this.id = options.id
        if (options?.nom) this.nom = options.nom
        if (options?.prenom) this.prenom = options.prenom
        if (options?.email) this.email = options.email
        if (options?.roleEnum) this.roleEnum = options.roleEnum
        if (options?.role) this.role = options.role
        if (options?.permissions) this.permissions = options.permissions
        if (options?.codeClientBiobank) this.codeClientBiobank = options.codeClientBiobank
        if (options?.DomTom) this.domTom = options.domTom
        if (options?.Dentaire) this.dentaire = options.dentaire
        if (options?.Maxilo) this.maxilo = options.maxilo
        if (options?.Ortho) this.ortho = options.ortho
        if (options?.fonction) this.fonction = options.fonction
        if (options?.autresInfos) this.autresInfos = options.autresInfos
        if (options?.desactive) this.desactive = options.desactive
        if (options?.inscriptionTerminee) this.inscriptionTerminee = options.inscriptionTerminee
        if (options?.listePMNAutorisees) this.listePMNAutorisees = options.listePMNAutorisees

        return this
    }
}
